export enum CookieKeys {
  CookieConsent = "FINZY_COOKIE_CONSENT"
}
